export default __webpack_public_path__ + "static/media/info.d7bbfac1.svg";